





















import { Vue, Component, Prop } from "vue-property-decorator";
@Component
export default class MiCollapse extends Vue {
  visible = false;
  @Prop({ type: Boolean }) disabled!: boolean;

  get right() {
    if (this.visible) {
      return {
        text: "点击隐藏详情",
        icon: "el-icon-arrow-up"
      };
    } else {
      return {
        text: "点击展开详情",
        icon: "el-icon-arrow-right"
      };
    }
  }
}
